/**
 * Generate a secure random string. This is for authentication purposes.
 * @returns Random string.
 */
export const generateRandomString = (length: number = 28) => {
    const array = new Uint32Array(length);
    window.crypto.getRandomValues(array);
    return Array.from(array, (value) => ("0" + value.toString(16)).substr(-2)).join("");
};
